import { z } from 'zod';

export const websocketTokenSchema = z.object({
  WEBSOCKET_TOKEN: z.string(),
});

export type WebsocketToken = z.infer<typeof websocketTokenSchema>;
